"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimStringInObject = exports.promiseWithTimeout = exports.spacingTrimAndToUpperCase = exports.spacingTrimAndToTitleCase = exports.spacingTrim = exports.uniqueArray = exports.shuffleArray = exports.convertCentsToPrice = exports.convertToDecimalPrice = exports.convertToCents = exports.toTitleCase = exports.sortArray = exports.isEmpty = exports.getStateFromPostCode = void 0;
function between(x, min, max) {
    return x >= min && x <= max;
}
const getStateFromPostCode = (postcode) => {
    const code = Number(postcode.substring(0, 5));
    if (code) {
        if (between(code, 50000, 60000))
            return 'Kuala Lumpur';
        if (between(code, 62300, 62988))
            return 'Putrajaya';
        if (between(code, 87000, 87033))
            return 'Labuan';
        if (between(code, 40000, 48300))
            return 'Selangor';
        if (between(code, 63000, 68100))
            return 'Selangor';
        if (between(code, 20000, 24300))
            return 'Terengganu';
        if (between(code, 93000, 98859))
            return 'Sarawak';
        if (between(code, 88000, 91309))
            return 'Sabah';
        if (between(code, 5000, 9810))
            return 'Kedah';
        if (between(code, 15000, 18500))
            return 'Kelantan';
        if (between(code, 70000, 73509))
            return 'Negeri Sembilan';
        if (between(code, 10000, 14400))
            return 'Pulau Pinang';
        if (between(code, 79000, 86900))
            return 'Johor';
        if (between(code, 75000, 78309))
            return 'Melaka';
        if (between(code, 1000, 2999))
            return 'Perlis';
        if (between(code, 30000, 36810))
            return 'Perak';
        if (between(code, 25000, 28800))
            return 'Pahang';
        if (between(code, 39000, 39200))
            return 'Pahang';
        if (code === 49000)
            return 'Pahang';
        if (code === 69000)
            return 'Pahang';
    }
    return null;
};
exports.getStateFromPostCode = getStateFromPostCode;
const isEmpty = (value) => {
    return (value === null ||
        value === undefined ||
        value === '' ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
exports.isEmpty = isEmpty;
const sortArray = (objArr, dataToSort) => {
    var sortedArr = objArr.slice(0);
    sortedArr.sort(function (a, b) {
        var x = a[dataToSort].toLowerCase();
        var y = b[dataToSort].toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
    });
    return sortedArr;
};
exports.sortArray = sortArray;
const toTitleCase = (text) => {
    return text.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
exports.toTitleCase = toTitleCase;
const convertToCents = (value) => {
    return Math.round(100 * value);
};
exports.convertToCents = convertToCents;
const convertToDecimalPrice = (value) => {
    return value / 100;
};
exports.convertToDecimalPrice = convertToDecimalPrice;
const convertCentsToPrice = (value) => {
    return (value / 100).toFixed(2);
};
exports.convertCentsToPrice = convertCentsToPrice;
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return exports.uniqueArray(array);
};
exports.shuffleArray = shuffleArray;
const uniqueArray = (arr) => {
    return arr.filter((object, index) => index === arr.findIndex((obj) => JSON.stringify(obj) === JSON.stringify(object)));
};
exports.uniqueArray = uniqueArray;
const spacingTrim = (text) => {
    return text.replace(/\s+/g, ' ').trim();
};
exports.spacingTrim = spacingTrim;
const spacingTrimAndToTitleCase = (text) => {
    return exports.spacingTrim(exports.toTitleCase(text));
};
exports.spacingTrimAndToTitleCase = spacingTrimAndToTitleCase;
const spacingTrimAndToUpperCase = (text) => {
    return exports.spacingTrim(text.toUpperCase());
};
exports.spacingTrimAndToUpperCase = spacingTrimAndToUpperCase;
const promiseWithTimeout = (millis, promise) => {
    const timeout = new Promise((_resolve, reject) => setTimeout(() => reject(`Timed out after ${millis} ms.`), millis));
    return Promise.race([promise, timeout]);
};
exports.promiseWithTimeout = promiseWithTimeout;
const trimStringInObject = (obj) => {
    Object.keys(obj).map((k) => (obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]));
    return obj;
};
exports.trimStringInObject = trimStringInObject;
//# sourceMappingURL=Utils.js.map